/**
 * Paths of the public main site pages (mounted at the site root, under the optional locale prefix,
 * in `routes.js`). Defined once here: the route definitions and the Cloudflare Pages Function that
 * writes their head tags for crawlers [F35] both read them, so a renamed page cannot lose its preview.
 * No imports on purpose — the Pages bundler and `node --test` load this file as it is.
 */
export const MainPath = {
  HOME: '',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  PRICING: 'pricing',
  PRICING_ORGANIZATION: 'pricing/organization',
  PRIVACY: 'privacy',
  TERMS: 'terms',
  TERMS_TRAINER: 'terms/trainer',
  COOKIES: 'cookies',
  FEATURES: 'features',
  FAQ: 'faq'
}

/**
 * Main pages search engines must not index (Ansis, 2026-10-25): legal texts are not what anyone
 * should find ASport by. They stay reachable and keep their link preview; robots says `noindex`.
 * Not blocked in robots.txt: a blocked page is never fetched, so its `noindex` is never seen.
 */
export const NON_INDEXED_MAIN_PATHS = [
  MainPath.TERMS_AND_CONDITIONS,
  MainPath.PRIVACY,
  MainPath.TERMS,
  MainPath.TERMS_TRAINER,
  MainPath.COOKIES
]
